import React, { useLayoutEffect, useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import policyInfoIcon from '../../assets/policy/information-icon.svg';
import { ORCA_CHANGE_COVERAGE } from '../navigation/routes.constants';
import { PPU_MARKETING_CHANNELS } from '../../theme/theme.constants';
import { POLICY_STATUS } from '../../constants';

import './PolicyNotificationCCOrcaCanada.css';
import { resetChangeCoverageOrca } from '../../actions';
import { getOrcaPolicyCodeByName, ORCA_PRODUCT_CODES } from './changeCoverage/utils/orcaChangeCoverage.utils';
import { useOrcaChangeCoverage } from '../../hooks';
import { formatShortDateByLanguage } from '../../services/language.utils';

// WIP: backend work on endpoint... maybe
// WIP: return 67, only for dev
const DAYS_TO_SHOW = 67;

const PolicyNotificationCCOrcaCanada = ({ petId, policy }) => {
  const { t } = useTranslation('insurance');
  const history = useHistory();
  const dispatch = useDispatch();
  const useChangeCoverage = useOrcaChangeCoverage();

  const isOrcaCa = useMemo(() => PPU_MARKETING_CHANNELS
    .includes(policy.MarketChannelId), [policy]);

  const url = useMemo(() => {
    if (!policy) {
      return '';
    }
    const { MarketChannelId, Id, CoveragePeriodId } = policy;

    const coveragePeriodId = `coveragePeriodId=${CoveragePeriodId}`;
    const petIdQuery = `petId=${petId}`;

    return `${ORCA_CHANGE_COVERAGE}?${coveragePeriodId}&${petIdQuery}`
      .replace(':marketingChanelId', MarketChannelId)
      .replace(':policyNumber', Id);
  }, [policy]);

  const onRenew = () => {
    history.push(url);
  };

  const days = useMemo(() => {
    if (!policy?.PolicyEndDate) {
      return 0;
    }

    const endDate = new Date(policy.PolicyEndDate.split('T')[0]);
    const toDay = new Date();

    const diff = Math.abs(toDay - endDate);
    const value = Math.floor(diff / (1000 * 60 * 60 * 24));

    return value;
  }, [policy?.PolicyEndDate]);

  const show = useMemo(() => {
    const { CoverageSummary } = policy?.PetCoveragesByPet || {};

    if (!CoverageSummary) {
      return false;
    }

    const productName = getOrcaPolicyCodeByName(CoverageSummary.ProductName);

    if (!useChangeCoverage) {
      return null;
    }

    return productName === ORCA_PRODUCT_CODES.accidentIllness
      && policy?.Status === POLICY_STATUS.active
      && days <= DAYS_TO_SHOW
      && isOrcaCa;
  }, [policy]);

  useLayoutEffect(() => {
    dispatch(resetChangeCoverageOrca());
  }, []);

  if (!show) {
    return null;
  }

  return (
    <div className="Policy-alerts-container">
      <div
        className="Policy-renewal-info-container"
      >
        <img
          alt="policy alert"
          className="Policy-alert-icon"
          src={policyInfoIcon}
        />

        <div className="Policy-alert-content-orca">
          <span className="Policy-alert-info-title">
            {t('changeCoverageOrcaCa.title',
              {
                date: formatShortDateByLanguage(policy?.PolicyEndDate),
                interpolation: { escapeValue: false },
              })}
          </span>

          <div className="Policy-alert-description-container-orca">
            <span className="Policy-alert-info-description-orca">
              <Trans
                components={{ b: <strong /> }}
                i18nKey="changeCoverageOrcaCa.description"
                ns="insurance"
                t={t}
                values={{
                  date: formatShortDateByLanguage(policy?.PolicyEndDate),
                  interpolation: { escapeValue: false },
                }}
              />
            </span>

            <button
              className="Policy-alert-info-link-button"
              onClick={onRenew}
              type="button"
            >
              {t('reviewButton')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export { PolicyNotificationCCOrcaCanada };
